import { useTranslation } from 'react-i18next';

import { NameInput } from '@/components/ProfileData/Inputs/NameInput.tsx';
import { BioTextarea } from '@/components/ProfileData/Inputs/BioTextarea.tsx';
import { GenderRadioGroup } from '@/components/ProfileData/GenderRadioGroup';
import { StepTitle } from '@/components/common/Steps/Steps.tsx';
import { BirthdayTrigger } from '@/components/ProfileData/Birthday/BirthdayTrigger.tsx';

type UserData = {
  name: string;
  about_me: string;
  birthday: string;
  gender: string;
};

export type UserDataProps = UserData & {
  updateFields: (fields: Partial<UserData>) => void;
};

export function UserData({
  name,
  about_me,
  birthday,
  gender,
  updateFields
}: UserDataProps) {
  const { t } = useTranslation();

  return (
    <div>
      <StepTitle
        title={t('registration.create_profile')}
        subTitle={t('registration.create_profile_sub')}
      />
      <NameInput name={name || ''} updateFields={updateFields} />
      <div style={{ marginTop: 24 }}>
        <BioTextarea
          about_me={about_me || ''}
          updateFields={updateFields}
          isRegistration={true}
        />
      </div>
      <BirthdayTrigger birthday={birthday || ''} updateFields={updateFields} />
      <GenderRadioGroup gender={gender} updateFields={updateFields} />
    </div>
  );
}
